/**
 * AI-companion routing predicates. (CORE-618 — the Stream `resolveChannel`
 * helper was removed with the rest of the Stream transport; these pure
 * predicates are backend-agnostic and stay.)
 */

/** `true` for the AI-companion entity type (Agapella & friends). */
export const isAiTarget = (entityType: string): boolean => entityType === 'ai';

/**
 * `true` when a ChatApi channel key belongs to the AI companion or the Wisdom
 * Council — the only channels `page_context` should ride along with. Companion
 * keys are minted server-side as `ai-<user>-<companion>`; the council key is
 * `wisdom-council-<user>` (see Agape.ChatApi + ChatApiCompanionPanel). DMs,
 * circles and event threads use their own ids and are excluded.
 */
export const isAiCompanionChannelKey = (key: string | undefined | null): boolean =>
  !!key && (key.startsWith('ai-') || key.startsWith('wisdom-council-'));

/**
 * Custom channel data the backend webhook keys on to route a DM to the AI
 * responder. Without it the webhook ignores the channel and the bot stays
 * silent (the «first-message-ignored» bug).
 */
export const aiCompanionData = (companionId: string) => ({
  is_ai_companion: true,
  companion_id: companionId,
});
